import Typography from '@mui/material/Typography';
import GridmapMap from './GridmapMap';
import { getAcisData } from '../js/dataAccessRoutines';
import { roundValue } from '../js/utilityRoutines';

// Gridded map image //

const setGridmapResultState = (results, setResult, userParams) => {
  if (results) {
      const code = (
        <GridmapMap 
            results={results}
            userParams={userParams}
        />
      );
      setResult(code)
  } else {
    setResult("")
  }
}

const processData = (res, userParams, setUserParams, imageParams) => {
  if (userParams.smry === 'cntdys') {
    res.range[0] = roundValue(res.range[0], 0)
    res.range[1] = roundValue(res.range[1], 0)
    res.levels = res.levels.map((lev) => { return roundValue(lev, 0) })
  } else if (userParams.variable === "pcpn") {
    res.range[0] = roundValue(res.range[0], 2)
    res.range[1] = roundValue(res.range[1], 2)
    res.levels = res.levels.map((lev) => { return roundValue(lev, 2) })
  } else {
    res.range[0] = roundValue(res.range[0], 1)
    res.range[1] = roundValue(res.range[1], 1)
    res.levels = res.levels.map((lev) => { return roundValue(lev, 1) })
  }
  const newClevels = res.levels.concat(Array(10).fill("")).slice(0, Math.max(10, res.levels.length))
  const newCmap = (typeof imageParams.cmap === 'string' || imageParams.cmap instanceof String) ? imageParams.cmap : userParams.cmap;
  setUserParams({...userParams, clevels: newClevels, colors: res.cmap, cmap: newCmap})
  return res
}

export function processGridmap(userParams, setResult, hourlyVx, setUserParams) {
  var duration, interval, toDate;
  const overlays = [];
  if (userParams.overlays.state) { overlays.push("state:1:black") };
  if (userParams.overlays.county) { overlays.push("county:0.5:grey") };
  const imageParams = {
      proj: "lcc", //"3857" for Leaflet map
      width: 800, 
      interp: userParams.interp,
      overlays: overlays,
  };
  const userPropLevels = userParams.clevels.filter(x => x != "");
  if (userPropLevels.length > 0) {
    imageParams['levels'] = userPropLevels;
  }
  const userColors = userParams.colors;
  if (userColors.length > 0) {
    imageParams['cmap'] = userColors;
  } else if (userParams.cmap === "") {
    imageParams['cmap'] = userParams.variable === 'pcpn' ? "RdYlGn" : "jet"
  } else {
    imageParams['cmap'] = userParams.cmap;
  }
  const areaType = userParams.areaType === "bbox" ? "bbox" : "state";       //"region" consists of list of states, as well
  const reduce = userParams.smry === 'cntdys' ? "cnt_" + userParams.operator + "_" + userParams.thresh : userParams.smry;
  const wholeMonths = userParams.fromDate.date() === 1 && userParams.toDate.date() === userParams.toDate.daysInMonth();
  if (wholeMonths) {
    toDate = userParams.toDate.format('YYYY-MM')
    interval = [0,1]
	  duration = userParams.toDate.diff(userParams.fromDate, 'month') + 1;	//difference between start/end dates in months
  } else {
    toDate = userParams.toDate.format('YYYY-MM-DD')
    interval = [0,0,1]
	  duration = userParams.toDate.diff(userParams.fromDate, 'day') + 1;	//difference between start/end dates in days
  }
  const acisParams = {
      [areaType]: userParams.area,
      grid: userParams.grid,
      date: toDate,
      elems:[{
        name: userParams.variable,
        interval: interval,
        duration: duration,
        reduce: reduce,
      }],
      output: "json",
      image: imageParams,
    }
    getAcisData(acisParams)
      .then(res => {
        const results = processData(res, userParams, setUserParams, imageParams);
        setGridmapResultState(results, setResult, userParams)
      })
      .catch(error =>  { 
        console.log("Data retrieval error: " + JSON.stringify(error)); 
        setResult((
          <Typography sx={{color: "red"}}>
            {"Error processing request " + JSON.stringify(error)}
          </Typography>
        ))
      })
  }